import styled from 'styled-components';

const ColorVariantWrapper = styled.div`
    display: flex;
    flex-direction: column;
    transition: width 0.3s ease-in-out;
    width: ${({ widthValue }) => `calc(100% * ${widthValue})`};
`;

export default ColorVariantWrapper;
